/*
saikrishna 11/04/2022 2700430604 new form created
Sohel 11/08/2022 2700430604 Integrated Save API
Sohel 11/09/2022 2700430604 Added Field List Code
Guru Prasad 11/09/2022 2700430604 Added Field List Code
Prakash Gummala 11/10/2022 2700430604 Fixed Table Alignments.
Sohel 11/14/2022 2700430604 fixed redirect issue
Sohel 11/14/2022 2700430604 Save API Payload Changes
Sohel 11/15/2022 2700430604 Save API Payload Changes
Ravi 2700430604 Added stepper tabs  toast messages
Sohel 12/01/2022 2700430604 Added Override Type in payload.
Dilip 12/05/2022  2700430604 Removed unecesarry console.log statements
Akhila 12/15/2022 2700430604 Added Role based access
Sohel 12/16/2022 2700430604 removed Field List Code in Payload
Ashraf 12/20/2022 2700430604 fixed user role access
sai Krishna 12/23/2022 2700430604 added Triggercode  and Trigger description
Saikrishna 01/05/2023 2700430604 change the filter download toaster message
Lalitha 01/10/2023 2700430604  fixed download configuration issue
Akhila 01/20/2023 2700430604 unsaved chnages alert popup issue fixed
Akhila 01/20/2023 2700430604 bugFixed unsaved changes issue
Sohel 02/16/2023 2701135832 Trigger Maintenance Payload Changes
Raghu 02/22/2023 2701135832 new UI buttons changes
Dilip 02/22/2023 2700430604 added download usage configuration
Sohel 03/13/2023 2700430604 Added Last Step in payload and Fixed isDraft issue
Sohel 01/31/2023 2701334326 Action Dropdown Changes
Sohel 01/31/2023 2701334326 added Stop Letter and request Letter Functionality
Akhila 05/31/2023 2701334326 unsaved changes bug fixed
Akhila 06/21/2023 2701334326 conditionally disable save and finish button on submission
Dilip-pds 10/31/2023 2701334326 added field based on Add/Remove Billing Indicator
*/
import React, {useEffect, useState, useContext} from 'react';
import {
  Grid,
  Button,
  Typography,
} from '@material-ui/core';
import DialogBox from '../../../../components/DialogBox';
import {useDispatch, useSelector} from 'react-redux';
import PageLoader from '../../../../components/PageLoader';
import AddAction from './AddAction';
import ActionsTable from './ActionsTable';
import {
  fetchEventTacticActions,
  postEventTactic,
  fetchEventTactic,
  fetchBillingIndicator,
  ResetEventTacticParams as resetEventTacticParams,
  ResetMessage as resetMessage,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import {
  fetchFilterRuleGroup,
} from '../../../../redux/reducers/BRE/AddRuleGroup';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import BreadCrums from '../../../../util/BreadCrum';
import {resetPrintUsageData} from '../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../redux/reducers/CommonActions/commonActions';
const TriggerActions = ({
  setValue,
  handleBack,
  activeStep,
  steps,
  stepSuccessMsg,
  setStepSuccessMsg,
  rowSelected: editExisting,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [addActionDialogOpen, setAddActionDialogOpen] = useState(false);
  const [editActionOpen, setEditActionOpen] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [actionTableData, setActionTableData] = useState([]);
  const [deletedActionIds, setDeletedActionIds] = useState([]);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    addEventTacticStatus,
    eventTacticData,
    errorMsg,
    successMsg,
    isLoading,
    triggerId,
    eventTacticsActionsList,
    downloadSuccessMsg,
  } = useSelector(({addEventTactic}) => addEventTactic);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const {roleData} = useSelector(({role}) => role);
  const roleDataDisable = roleData?.window?.['Triggers Maintenance']?.TM;

  const handleAddActionDialog = () => {
    setAddActionDialogOpen(false);
    setEditActionOpen(false);
    dispatch(resetEventTacticParams());
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (Object.keys(eventTacticData).length > 0) {
      eventTacticData?.ruleGroupId && dispatch(fetchFilterRuleGroup(eventTacticData?.ruleGroupId));
      const data = [...eventTacticData?.actions];
      const actionsData = data.map((i) => {
        let va = {};
        eventTacticsActionsList?.filter((item) => {
          if (item.valueCode === i.action) {
            va = {valueCode: item?.valueCode, value: item?.value};
            return;
          }
        });
        return {...i, action: {...va}};
      });
      const newData = actionsData.map((i) => {
        //  let ar = Object.keys(i.params).forEach(([key, value]) => {
        //     if(key === window){
        //      return value?.
        //     }
        //   });
        return {
          ...i.params,
          seqNo: i.seqNo,
          action: i.action,
          params: i.params,
          actionId: i.actionId,
        };
      });
      setActionTableData(newData);
    }
  }, [eventTacticData, eventTacticsActionsList]);
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const actions = actionTableData.map((data) => {
      const obj = {...data};
      delete obj.action;
      delete obj.tableData;
      const action = {
        action: data.action.valueCode,
        actionId: 0,
        ...obj,
      };
      return action;
    });
    const passValues = {
      actions: actions,
      deletedIds: deletedActionIds,
      code: eventTacticData?.code ? eventTacticData?.code : triggerId,
      id: eventTacticData?.id ? eventTacticData?.id : 0,
      description: eventTacticData?.description ? eventTacticData?.description : '',
      mode: eventTacticData?.mode ? eventTacticData?.mode : '',
      ruleGroupCode: eventTacticData?.ruleGroupCode ? eventTacticData?.ruleGroupCode : '',
      seedOnly: eventTacticData?.seedOnly ? eventTacticData?.seedOnly : '',
      event: eventTacticData?.event ? eventTacticData?.event : '',
      isDraft: 'N',
      name: '',
      ruleGroupId: eventTacticData?.ruleGroupId ? eventTacticData?.ruleGroupId : 0,
      triggerOwner: '',
      type: '',
      version: '',
      versionNumber: 0,
      overrideType: 'TRIGGER',
      clientCode: eventTacticData?.clientCode?.length > 0 ? eventTacticData?.clientCode : [],
      lastStep: eventTacticData?.isDraft === 'N' ? eventTacticData?.lastStep : 3,
    };
    dispatch(postEventTactic(passValues));
  };

  useEffect(() => {
    if (triggerId) {
      dispatch(fetchEventTactic(triggerId));
    }
  }, [triggerId]);
  useEffect(() => {
    if (addEventTacticStatus === 200 && !errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        setValue(0);
      }, 1000);
    }
  }, [addEventTacticStatus, errorMsg]);

  useEffect(() => {
    if (downloadSuccessMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 1500);
    }
  }, [downloadSuccessMsg]);

  useEffect(() => {
    if (errorMsg || successMsg) {
      if (successMsg) {
        activeStep === 2 && setStepSuccessMsg(`${steps[2]} Added/Modified Successfully`);
      }
      setTimeout(() => {
        dispatch(resetMessage());
        setStepSuccessMsg('');
      }, 1000);
    }
  }, [errorMsg, successMsg]);

  useEffect(() => {
    dispatch(fetchEventTacticActions());
    dispatch(fetchBillingIndicator());
  }, []);
  return (
    <>
      <div className={`rounded mb-0`}>
        {eventTacticData?.actions && (
          <BreadCrums
            name={'Trigger Name'}
            code={eventTacticData?.code}
            description={'Trigger Description'}
            descriptionValue={eventTacticData?.description}
          />
        )}
        <ErrorBoundaryForComponents>
          <Grid xs={12}>
            <div>
              <div className="new-standard-textfields table-card-header table-header">
                <Typography variant="h3">Actions </Typography>
                <Button
                  variant="outlined"
                  className={`search-btn ${classes.buttonRoot}`}
                  onClick={() => setAddActionDialogOpen(true)}
                >
                  <AddIcon />
                  Add Action
                </Button>
              </div>
              <div>
                <ActionsTable
                  setActionTableData={setActionTableData}
                  actionTableData={actionTableData}
                  setDeletedActionIds={setDeletedActionIds}
                  deletedActionIds={deletedActionIds}
                  setAddActionDialogOpen={setAddActionDialogOpen}
                  setEditActionOpen={setEditActionOpen}
                  handleDirty={handleDirty}
                />
              </div>
            </div>
          </Grid>
        </ErrorBoundaryForComponents>

        <div className="new-standard-textfields d-flex justify-content-center mt-3">
          <Button
            variant="outlined"
            onClick={() => {
              handleBack();
            }}
            className={`reset-btn mr-1 ${classes.buttonRoot}`}
          >
            Back
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              handleSubmit();
            }}
            disabled={
              actionTableData?.length === 0 ||
              (eventTacticData?.actions?.length > 0 &&
                roleDataDisable?.edit === false &&
                editExisting) ||
              enabledSubmission
            }
            className={`search-btn ml-1 ${classes.buttonRoot}`}
          >
            Finish
          </Button>
        </div>

        <DialogBox
          open={addActionDialogOpen || editActionOpen}
          dialogClose={handleAddActionDialog}
          title={editActionOpen ? `Edit Action` : `Add Action`}
          maxWidth="lg"
        >
          <AddAction
            setSearchData={setSearchData}
            // handleClose={handleClose}
            handleAddActionDialog={handleAddActionDialog}
            setActionTableData={setActionTableData}
            searchData={searchData}
            actionTableData={actionTableData}
            editActionOpen={editActionOpen}
            handleDirty={handleDirty}
          />
        </DialogBox>
        {(isLoading || printUsageIsLoading) && <PageLoader />}
        {(errorMsg || printUsageErrorMsg) && (
          <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
        )}
        {(stepSuccessMsg || downloadSuccessMsg || printUsageSuccessMsg) && (
          <SuccessSnackbar
            successMsg={stepSuccessMsg || downloadSuccessMsg || printUsageSuccessMsg}
          />
        )}
      </div>
    </>
  );
};

export default TriggerActions;
